// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dH-z","hovered":"eH-z","hoverImage":"fH-z","mainImage":"gH-z","imageNoBackground":"hH-z","fullSizeImage":"iH-z"};